/** 业务 code（与 PHP `app\common\ApiCode`、补货端 `replenisher/src/constants/apiCode.js` 对齐） */
export const API_CODE = {
  OK: 200,
  AUTH_SWITCH: 201,
  /** 校验失败，与 ThinkPHP ValidateException、ApiCode::VALIDATION_FAILED 一致 */
  VALIDATION_FAILED: 422,
  BIZ_ERROR: 500,
  TOKEN_INVALID: 501,
  PTOKEN_INVALID: 502,
  NOT_ADMIN: 503,
  REDIRECT: 504,
  WX: 505,
}
